import React from 'react'

const Contact = () => {
  return (
    <div className='xl:px-[10%] lg:px-[8%] xs:px-[5%] md:px-[6%] sm:px-[5%]  xs:flex-col flex  xs:gap-0 gap-6   '>
      <div className='w-full sm:w-1/2 xs:py-2  py-10'>
        <div className='flex flex-col pr-6 xs:pr-0 border-r-2 xs:border-r-0 sm:border-b-0 sm:border-r-2'>
          <h1 className='font-inter flex pt-6 justify-center font-medium xs:text-[20px] text-[35px] sm:text-[30px] text-center'>
            Stay in touch
          </h1>
          <p className='font-inter text-[#777] text-[16px] xs:text-[12px] sm:text-[14px] text-center'>
            Want to stay connected and receive tips on how to be more productive and have a better digital well-being? And of course, news from the world of Drunkmates?
          </p>
          <div className='pt-6 flex xs:pb-0 pb-6 gap-4  '>
            <input
              type="text"
              className='pl-2 w-full xs:py-2 sm:w-[80%] rounded-xl py-4 border mb-4 '
              placeholder='E-mail'
            />
            <div>  <button className='bg-[#870022] rounded-2xl  xs:py-2   py-4  text-white font-medium px-6'>
              Submit
            </button></div>
          
          </div>
        </div>
      </div>
      
      <div className='w-full sm:w-1/2 xs:py-2 py-10'>
        <div className='flex flex-col'>
          <h1 className='font-inter xs:pt-0 flex  xs:text-[20px] pt-6 justify-center font-medium text-[35px] sm:text-[30px] text-center'>
            Join our whatsapp channel 
          </h1>
          <p className='font-inter text-[#777] text-[16px] xs:text-[12px] sm:text-[14px] text-center'>
            Join our Discord community for more productivity tips and participate in our monthly challenges and win  amazing rewards.
          </p>
          <div className='pt-6 flex justify-center pb-6 gap-4'>
            <img 
              src="https://cdn-icons-png.freepik.com/256/3536/3536445.png?ga=GA1.1.1729423842.1728456719&semt=ais_hybrid" 
              alt="Join Discord" 
              className='xl:w-[100px] sm:w-[70px] lg:w-[70px] xs:w-[60px] md:w-[70px]'
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Contact




// import React from 'react'

// const Contact = () => {
//   return (
//     <div className='container flex gap-6 bg-white mx-auto'>
// <div className='w-1/2 py-10  '>
// <div className='flex flex-col pr-6 border-r-2'>
// <h1 className='font-inter flex pt-6 justify-center font-medium text-[35px]'> Stay in touch </h1>
// <p className='flex font-inter text-[#777] text-[16px] text-center '>Want to stay connected and receive tips on how to be more productive and have a better digital well-being? And of course, news from the world of AppBlock?</p>
// <div className='pt-6 flex pb-6 gap-4'>
//     <input type="text"  className='pl-2 w-[80%] rounded-xl py-4 border' placeholder='E-mail'/>
//     <button className='bg-[#2f96ff] rounded-2xl py-4 text-white font-medium px-6'>Sumit</button>
// </div>
// </div> 

// </div>
// <div className='w-1/2 py-10 '>
// <div className='flex flex-col '>
// <h1 className='font-inter flex pt-6 justify-center font-medium text-[35px]'> Join our Discord  </h1>
// <p className='flex font-inter text-[#777] text-[16px] text-center '>Join our Discord community for more productivity tips and participate in our monthly challenges and win amazing rewards.</p>
// <div className='pt-6 flex justify-center pb-6 gap-4'>
//   <img src="https://appblock.app/wp-content/uploads/2024/04/discord-button-1.svg" alt="" />
// </div>
// </div> 

// </div>
//     </div>
//   )
// }

// export default Contact